import { TValidator } from "../../../../wizard/types";
import { isPositiveNumber, isValidURL } from "../../../../../helpers";
import { DurationUnit } from "../../../../../types";
import { CourseType } from "../../../types";

type CommonObject = { [key: string]: any };

const innerValidator: TValidator = async ({ values, activeStepName }) => {
  const errors: CommonObject = {};

  const activeStepValues = values[activeStepName] ?? {};
  const isDisabledHousingType =
    +values?.step1?.courseType === CourseType.ONLINE;

  // Required Documents -----------------------------------------------
  if (!activeStepValues?.requiredDocs?.length) {
    errors.requiredDocs = "Please select at least 1";
  }

  // Application Files -----------------------------------------------
  if (
    activeStepValues.applicationLink?.trim() &&
    !isValidURL(activeStepValues.applicationLink)
  ) {
    errors.applicationLink = "Please insert a valid URL";
  }

  // Course Duration -----------------------------------------------
  if (!activeStepValues.durationUnit) {
    errors.durationUnit = "Duration period is required";
  }

  if (activeStepValues?.durationUnit?.id !== DurationUnit.FULL) {
    const durationAmount = activeStepValues.durationAmount?.trim();

    if (!durationAmount) {
      errors.durationAmount = "Duration is required";
    } else if (!isPositiveNumber(+durationAmount)) {
      errors.durationAmount = "Duration is not valid";
    } else if (durationAmount >= 10000) {
      errors.durationAmount = "Max 4 digits allowed";
    } else if (durationAmount.split(".")[1]?.length > 2) {
      errors.durationAmount = "Max 2 digits allowed after decimal point";
    }
  }

  // Housing Type -------------------------------------------------
  if (!isDisabledHousingType && !activeStepValues?.housingTypes?.length) {
    errors.housingTypes = "Housing type is required";
  }

  if (Object.keys(errors).length > 0) {
    throw {
      [activeStepName]: errors,
    };
  }
};

export default innerValidator;
